import { render, staticRenderFns } from "./confirmacion-suscripcion.vue?vue&type=template&id=62e21d7b"
import script from "./confirmacion-suscripcion.vue?vue&type=script&lang=js"
export * from "./confirmacion-suscripcion.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {HeaderConfirmation: require('/builds/marketing/abstracta.academy-website/components/HeaderConfirmation.vue').default})
